import styled from 'styled-components';
import FormWrapper from '../../components/FormWrapper';
import TableComponent from '../../components/Table';

export const Container = styled.section`
  grid-column: 2/10;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

export const Table = styled(TableComponent)`
  @media (max-width: 768px) {
    margin: 0px;
  }
`;

export const ContainerTitleIntern = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px !important;
  margin-bottom: 24px;

  > button {
    text-transform: uppercase;
  }
  h2 {
    margin: 0;
    font-size: 1.2rem;
    font-family: 'Unimed-Sans-Book';
  }
`;
